<script>
import _ from "lodash";
import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import ImageLightbox from '@/components/image-lightbox/image-lightbox'
import WebCamera from '@/components/utility/web-camera.vue'
import fullscreen from 'vue-fullscreen'
import Spinner from "vue-simple-spinner"
Vue.use(fullscreen)
import {isMobile, isMobileOnly} from 'mobile-device-detect'
import progressBar from '@/components/utility/progress-bar/progress-bar.vue'
import Axios from "axios";
import {appConfig} from "@/config";

export default({
  name: "rfq-statewide-add-parts",
  props: {
    value: {}
  },
  data() {
    return{
      files: [],
      openDropzone: false,
      isMobile,
      vehicleVinPhotos: [],
      partsPhotos: [],
      isDonutActive: false,
      isDonutActive2: false,
      makes: [
        'Alfa Romeo', 'Audi', 'Bentley',
        'BMW', 'Cupra', 'Chrysler',
        'Fiat', 'Haval', 'Holden',
        'Isuzu', 'Jac', 'Jaguar',
        'Jeep', 'Kia', 'Land-Rover',
        'Lexus', 'Mazda', 'Mercedes-Benz',
        'Mini', 'Mitsubishi', 'MG',
        'Nissan', 'Polestar', 'Porsche',
        'RAM', 'Renault', 'SsangYong',
        'Suzuki', 'Toyota', 'Volkswagen',
        'Volvo', 'McLaren', 'Aston Martin',
        'Lamborghini', 'Lotus', 'Ferrari',
        'Abarth', 'Pagani', '3M',
        'Brabus', 'Ppg', 'Sikkens',
      ],
      isFoundPrtNbrMatch: false,
      isShowCameraAi: {
        vin: false,
        parts: false
      },
      isShowCameraPart: false,
      isShowBrowseAi: {
        vin: false,
        parts: false
      },
      isShowBrowsePart: false,
      loadingAi: {
        vin: false,
        parts: false
      },
      imageUploadDropzoneOptions: {
        resizeWidth: 1500,
        resizeQuality: 0.7,
        url: appConfig.baseAPIURL + '/ir/repairer/rfq/uploadFile',
        //      url: appConfig.baseAPIURL + '/ir/user/photo/upload',
        headers: { 'Authorization': localStorage.getItem('token') },
        method: 'post',
        maxFilesize: 50,
        thumbnailWidth: 200,
        timeout: 300000,
        addRemoveLinks: true,
        acceptedFiles: 'image/jpeg, image/jpg, image/png',
        dictFileTooBig: 'Your file has exceeded the maximum limit of 5MB per file. Please reduce the file size and upload again'
      },
    }
  },
  components: {
    Multiselect,
    WebCamera,
    'vue-simple-spinner': Spinner,
    progressBar,
    vueDropzone: vue2Dropzone,
    ImageLightbox,
  },
  computed: {
    isDisabledAddToQuoteBtn () {
      return !(!_.isEmpty(this.value.description) || !_.isEmpty(this.value.partNumber)) || _.isEmpty(this.value.make) || _.isEmpty(this.value.vinVehicle)
    },
    showWarningEmptyVinVehicle(){
      return ((!_.isEmpty(this.value.description) || !_.isEmpty(this.value.partNumber)) && _.isEmpty(this.value.vinVehicle))
    },
    isPartsHaveLoadingAi() {
      return _.some(this.value.parts, (item) => item.ai_load === true)
    }
  },
  created() {
    this.debouncedSearchPrtNbr = _.debounce(this.searchPrtNbr, 500)
  },
  methods: {
    async onFileChange(event) {
      // Set loading state for the appropriate AI type
      if (this.isShowBrowseAi.vin) {
        this.loadingAi.vin = true
      }
      if (this.isShowBrowseAi.parts) {
        this.loadingAi.parts = true
      }

      const file = event.target.files[0];

      if (file) {
        const reader = new FileReader();
        reader.onload = async (e) => {
          try {
            let base64 = e.target.result

            if (this.isShowBrowsePart) {
              this.partsPhotos.push(base64)
            }

            if (this.isShowBrowseAi.vin) {
              await this.analyzeVinPhoto([base64])
            }

            if (this.isShowBrowseAi.parts) {
              await this.analyzePartsPhoto([base64])
            }

          } catch (error) {
            console.error('Error processing file:', error)
          } finally {
            // Reset all flags and loading states
            this.isShowBrowsePart = false;
            this.isShowBrowseAi.vin = false;
            this.isShowBrowseAi.parts = false;
            this.loadingAi.vin = false;
            this.loadingAi.parts = false;

            // Clear the file input to allow selecting the same file again
            if (event.target) {
              event.target.value = '';
            }
          }
        };

        reader.onerror = (error) => {
          console.error('FileReader error:', error)
          // Reset loading states on error
          this.loadingAi.vin = false;
          this.loadingAi.parts = false;
          this.isShowBrowseAi.vin = false;
          this.isShowBrowseAi.parts = false;

          // Clear the file input
          if (event.target) {
            event.target.value = '';
          }
        };

        reader.readAsDataURL(file);
      } else {
        // No file selected, reset states
        this.loadingAi.vin = false;
        this.loadingAi.parts = false;
        this.isShowBrowseAi.vin = false;
        this.isShowBrowseAi.parts = false;
      }
    },
    deleteImage: function (index, file) {
      this.deleteFile(file)
    },
    addFileUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = 'none'
    },
    successFileUpload (file, response) {
      if (response.status || response._status) {
        this.fileIds.push(response.fileId)
        this.autoSaveFile()
        let vm = this
        setTimeout(function () {
          vm.$refs.fileUpDropStatewide.removeFile(file)
        }, 1000)
      }
    },
    completeFileUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].removeAttribute('style')
    },
    sendFileUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = 'none'
    },
    getConfig: function () {
      return (this.type === 'image') ? this.getImagesConfig() : this.getFilesConfig()
    },
    clickOnBrowseFiles() {
      this.$refs.vueDropzoneButton.click();
    },
    clickCancelDropzoneFiles: function () {
      this.$refs.fileUpDropStatewide.removeAllFiles(true)
      this.fileIds = []
    },
    openCameraAi(type) {
      if (type=='parts' && _.isEmpty(this.value.vinVehicle)){
        return
      }
      if (type=='parts'){
        this.isShowCameraPart=true
      }else{
        this.isShowCameraPart=false
      }
      if (this.isMobile) {
        this.isShowCameraAi[type] = true
      } else {
        this.isShowBrowseAi[type] = true
        this.$refs.fileInput.click()
      }
    },
    openCameraParts() {
      if (this.isMobile) {
        this.isShowCameraPart = true
      } else {
        this.isShowBrowsePart = true
        this.$refs.fileInput.click()
      }
    },
    async analyzeVinPhoto(images) {
      this.isShowBrowseAi.vin = false;
      // TODO: Replace with actual RFQ endpoint
      await Axios.post('/stw/vin', { images: images })
        .then(resp => {
          if (resp.request.status == 200) {
            this.value.vinVehicle = resp.data.vin
          }
        })
        .catch(err => {
          console.log(err)
        }).finally(() => {
          this.loadingAi.vin = false
          this.vehicleVinPhotos = []
        })
    },
    async analyzePartsPhoto(photo) {
      let obj = {
        partDescription: '',
        partNumber: '',
        ai_load: true,
        completed: false,
        qty: 1
      }
      this.value.parts.push(obj)
      this.loadingAi.parts = false
      this.isShowCameraAi.parts = false
      this.isShowBrowseAi.parts = false;

      // TODO: Replace with actual RFQ parts endpoint
      await Axios.post('/stw/part', { images: photo })
        .then(resp => {
          if (resp.request.status == 200) {
            console.log('part', resp.data.part)
            obj.partDescription = resp.data.part.part_name
            obj.partNumber = resp.data.part.part_number
            obj.completed = true
          }
        })
        .catch(err => {
          console.log(err)
        }).finally(() => {
          this.loadingAi.parts = false
          this.isShowBrowseAi.parts = false;
          setTimeout(() => {
            obj.ai_load = false
          }, 1000)
        })

      this.loadingAi.parts = false
      this.vehicleVinPhotos = []
      this.isShowBrowseAi.parts = false;
    },
    async onCloseCamera(photos) {
      // Store the camera type before resetting flags
      const wasVinCamera = this.isShowCameraAi.vin;
      const wasPartsCamera = this.isShowCameraAi.parts;

      // Reset all camera flags
      this.isShowCameraPart = false;
      this.isShowCameraAi.vin = false;
      this.isShowCameraAi.parts = false;

      // Handle the photos if any were taken
      if (photos && photos.length > 0) {
        if (wasVinCamera) {
          this.vehicleVinPhotos = photos;
          this.loadingAi.vin = true;
          this.analyzeVinPhoto(photos);
        } else if (wasPartsCamera) {
          this.loadingAi.parts = true;
          this.analyzePartsPhoto(photos);
        } else {
          this.partsPhotos = photos;
        }
      }
    },
    async onSendCamera(photos) {
      this.loadingAi.parts = true
      await this.analyzePartsPhoto(photos)
    },
    getRefElement(refName) {
      let ref = this.$refs[refName]

      if (Array.isArray(ref)) {
        ref = ref[0]
      }

      if (!ref) {
        return null
      }

      if (ref.$el) {
        return ref.$el.querySelector('input') || ref.$el
      }

      return ref
    },
    focusByRef(refName) {
      const el = this.getRefElement(refName)
      if (el && el.focus) {
        el.focus()
        return true
      }
      return false
    },
    changePositionByArrowKey(refName) {
      this.focusByRef(refName)
    },
    findPartRefByDirection(index, step, field, includeStart = false) {
      const partsCount = _.get(this, 'value.parts.length', 0)
      if (!partsCount) {
        return null
      }

      let currentIndex = includeStart ? index : index + step
      while (currentIndex >= 0 && currentIndex < partsCount) {
        const refName = field == 'qty'
          ? 'statewidePartQty' + currentIndex
          : 'statewidePartDescription' + currentIndex

        if (this.getRefElement(refName)) {
          return refName
        }
        currentIndex += step
      }

      return null
    },
    focusFirstPartQty() {
      const refName = this.findPartRefByDirection(0, 1, 'qty', true)
      if (refName) {
        this.focusByRef(refName)
      }
    },
    onPressPartArrowKey(index, event) {
      if (!event || !event.code) {
        return
      }

      let refName = null

      if (event.code == 'ArrowDown') {
        refName = this.findPartRefByDirection(index, 1, 'qty')
        if (!refName) {
          refName = this.findPartRefByDirection(0, 1, 'qty', true)
        }
      } else if (event.code == 'ArrowUp') {
        refName = this.findPartRefByDirection(index, -1, 'qty')
        if (!refName) {
          this.focusByRef('partNumber')
          event.preventDefault()
          return
        }
      } else {
        return
      }

      if (refName && this.focusByRef(refName)) {
        event.preventDefault()
      }
    },
    upperCase (field) {
      this[field] = _.toUpper(this[field])
    },
    sleep (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    async searchPrtNbr() {
      this.isDonutActive = true
      await this.sleep(1000)
      if (this.value.partNumber == '6n971627a') {
        this.isFoundPrtNbrMatch = true
      } else {
        this.isFoundPrtNbrMatch = false
      }
      this.isDonutActive = false
      return true
    },
    addToQuoteList() {

      if ((!_.isEmpty(this.value.description) || !_.isEmpty(this.value.partNumber)) && !_.isEmpty(this.value.make) && !_.isEmpty(this.value.vinVehicle)){
        let obj = {
          partDescription: _.cloneDeep(this.value.description),
          partNumber: _.cloneDeep(this.value.partNumber),
          qty: 1
        }

        this.value.parts.push(obj)
        this.value.description = ''
        this.value.partNumber = ''
        this.isFoundPrtNbrMatch = false
        this.isDonutActive=false;
        this.$nextTick(() => {
          this.focusByRef('statewideAddDescription')
        })
        return true
      }
    },
  },
})
</script>

<template>
  <div class="d-flex">
    <web-camera v-if="isMobile && (isShowCameraPart || isShowCameraAi.vin || isShowCameraAi.parts)"
                :multiple="isShowCameraPart"
                :sendAfterTakePhoto="isShowCameraPart"
                @close="onCloseCamera"
                @send="onSendCamera"
    ></web-camera>
    <div class="wrapper-statewide">
      <div class="body-block d-flex">
        <div class="body-block-left">
          <div class="body-block-left-title">Vehicle Information</div>
          <div class="d-flex body-block-left-item">
            <div class="body-block-left-item-name">
              Make
            </div>
            <div class="body-block-left-item-input">
              <multiselect
                  ref="statewideMake"
                  v-model="value.make"
                  :options="makes"
                  style="width: 100%; text-transform: uppercase;"
                  :allowEmpty="false"
                  :showLabels="false"
                  v-on:keydown.native.down.capture.prevent="changePositionByArrowKey('statewideVinVehicle')"
              ></multiselect>
            </div>
          </div>
          <div class="d-flex body-block-left-item">
            <div class="body-block-left-item-name">
              Vehicle VIN <br>
              <span>Type in or Take a Photo of <br>
                the BUILD PLATE with VIN
              </span>
            </div>
            <div class="body-block-left-item-input d-flex">
              <input ref="statewideVinVehicle" v-model="value.vinVehicle" @change="upperCase('vinVehicle')" v-on:keydown.up.prevent="changePositionByArrowKey('statewideMake')" v-on:keydown.down.prevent="changePositionByArrowKey('statewideEstimateNumber')" type="text" style="width: 100%; text-transform: uppercase;" :class="{'red-blinker':showWarningEmptyVinVehicle && value.vinVehicle==''}">
              <div style="display: flex; justify-content: center;align-items: center;">
                <vue-simple-spinner v-if='loadingAi.vin' style="margin-left: 5px;" :size="23"></vue-simple-spinner>
                <i v-else @click="openCameraAi('vin')" class='bx bxs-camera clickable'></i>
              </div>
            </div>
          </div>
          <div class="d-flex body-block-left-item">
            <div class="body-block-left-item-name">
              Estimate Number
            </div>
            <div class="body-block-left-item-input d-flex">
              <input ref="statewideEstimateNumber" type="text" v-model="value.QPNumber" @change="upperCase('QPNumber')" v-on:keydown.up.prevent="changePositionByArrowKey('statewideVinVehicle')" v-on:keydown.down.prevent="changePositionByArrowKey('statewideAddDescription')" style=" text-transform: uppercase;">
            </div>
          </div>
          <div class="d-flex" style="margin-top: 40px; padding-top: 10px; border-top: 1px solid rgba(0, 0, 0, .25); margin-right: 20px; justify-content: space-between">
            <div class="body-block-left-title" >Create a Parts List</div>
            <div v-if="value.parts.length > 0" class="body-block-left-mobile-num-parts">{{ value.parts.length }}</div>
          </div>
          <div class="d-flex body-block-left-item">
            <div class="body-block-left-item-name">
              Add Part Description
            </div>
            <div class="body-block-left-item-input d-flex">
              <input ref="statewideAddDescription" type="text" v-model="value.description" @change="upperCase('description')" @keyup.enter="addToQuoteList" v-on:keydown.up.prevent="changePositionByArrowKey('statewideEstimateNumber')" v-on:keydown.down.prevent="changePositionByArrowKey('partNumber')" style="text-transform: uppercase; color: black !important; -webkit-text-fill-color: black; opacity: 1 !important;">
              <div style="display: flex; justify-content: center;align-items: center;">
                <vue-simple-spinner v-if='loadingAi.parts' style="margin-left: 5px;" :size="23"></vue-simple-spinner>
                <i v-else-if="value.vinVehicle != ''"
                   @click="openCameraAi('parts')"
                   class='bx bxs-camera clickable'
                   ></i>
              </div>
            </div>
          </div>
          <div class="d-flex body-block-left-item">
            <div class="body-block-left-item-name">
              Add Part Number
            </div>
            <div class="body-block-left-item-input d-flex">
              <input type="text" ref="partNumber" v-model="value.partNumber" @change="upperCase('partNumber')" @input="debouncedSearchPrtNbr" @keyup.enter="addToQuoteList" v-on:keydown.up.prevent="changePositionByArrowKey('statewideAddDescription')" v-on:keydown.down.prevent="focusFirstPartQty" style="padding-right: 27px;  text-transform: uppercase; color: black !important; -webkit-text-fill-color: black; opacity: 1 !important;">
              <div v-if="value.partNumber.length > 0 && isDonutActive">
                <div style="text-align: center; margin: 50px auto">
                  <div class="donut"></div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div v-if="isFoundPrtNbrMatch" class="d-flex body-block-left-item">
              <div class="body-block-left-item-name">
                Available at <br>
                <span>
                Locating your nearest <br>
                Parts dealership.
              </span>
                <div>
                  Shop with Confidence <br>
                  <span>Your information Safe</span>
                </div>
                <div>
                  Manufacturer Warranty <br>
                  <span>Minimum of 12 Months</span>
                </div>
              </div>
              <div class="available-right-block">
                <div class="body-block-left-item-info">
                  <div>
                    <img src="../../../../../public/img/auto-logo/audi.png" height="50" width="50">
                  </div>
                  <div class="body-block-left-item-info-title">
                    Fuel Injector Connector
                  </div>
                  <div class="body-block-left-item-info-availability">
                    Stock Availability
                    <span v-if="true" style="color: #00af4f; margin-left: 10px">In stock</span>
                    <span v-if="false" style="color: #fd0000; margin-left: 10px">Get Price & latest Stock quote</span>
                  </div>
                  <div class="body-block-left-item-info-qty">
                    Stock Qty <span style="margin-left: 55px">10 +</span>
                  </div>
                  <div class="body-block-left-item-info-dealership">
                    Your Dealership
                  </div>
                  <div class="body-block-left-item-info-name">
                    AUDI - Zagame Automotive
                  </div>
                  <div class="body-block-left-item-info-num">
                    Tullmarine - 3043
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex body-block-left-item">
            <div class="body-block-left-item-name" style="width: 40%">

            </div>
            <div class="body-block-left-item-input" style="width: 60%; height: 100px">
              <button @click="addToQuoteList" class="btn btn-add-quote" :class="{'disabled': isDisabledAddToQuoteBtn}" style="width: 100%;">Add to Quote List</button>
              <button v-if="isFoundPrtNbrMatch" @click="value.partNumber = ''; isFoundPrtNbrMatch = false; $refs.partNumber.focus()" class="btn btn-add-quote" style="width: 100%; margin-top: 10px; background-color: #333f4f; border-color: #333f4f;">Search Again</button>
            </div>
          </div>
        </div>
        <div class="body-block-right">
          <div class="body-block-right-title"  style="color: #562b77;">Parts List</div>
          <div class="body-block-right-subtitle">
            The parts list below will be sent to the dealership for a Price and Latest Stock quote.
          </div>

          <div v-if="value.parts.length > 0" class="table-body-block-right" :class="{'gray-table': false}">
            <div class="table-body-block-right-head d-flex">
              <div class="table-body-block-right-title" style="flex-grow: 1;">Part Description</div>
              <div class="table-body-block-right-title" style="width: 70px;">Qty</div>
              <div class="" style="width: 26px"></div>
              <div  class="table-body-block-right-title" style="width: 40px"></div>
            </div>
            <div class="table-body-block-right-body">
              <div v-for="(part, index) in value.parts" class="d-flex table-body-block-right-item" style="margin-bottom: 5px">
                <progress-bar v-if="part.ai_load" :completed="part.completed"></progress-bar>
                <template v-else>
                  <div style="flex-grow: 1;  text-transform: uppercase;">
                    <input :value="(part.partDescription?.length>0 && part.partNumber?.length>0)?(part.partDescription +' - '+ part.partNumber):(part.partDescription)?part.partDescription:part.partNumber  " tabindex="-1" readonly type="text" style="width: 100%; font-size: 11px;color: black !important; -webkit-text-fill-color: black; opacity: 1 !important; text-transform: uppercase;">
                  </div>
                  <div style="width: 70px; margin: 0 5px">
                    <input :ref="'statewidePartQty' + index" type="number" min="0" :value="part.qty" @keydown="onPressPartArrowKey(index, $event)" class="qty">
                  </div>
                  <div class=""
                       v-if="false && part.isStock"
                       style="width: 67px; background-color: rgb(0, 176, 80); color: white; border-radius: 6px; height: 32px; display: flex; align-items: center; justify-content: center; margin-right: 0px;">
                    In Stock
                  </div>
                  <div  class="table-body-block-right-item-icon d-flex" style="width: 50px">
                    <i @click="value.parts.splice(index, 1)" class='bx bx-trash' style="color: #c45408; cursor: pointer;"></i>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div v-if="false">
            <div>
              <i @click="openDropzone = !openDropzone" class='bx bx-image-add'></i>
            </div>
            <div v-if="openDropzone" style="position: relative;">
              <div class="block-uploader files-upload" style="width: 350px; height: 350px; overflow-y: auto; z-index: 2; position: absolute; top: -25px; left: 40px; user-select: none">
                <vue-dropzone v-on:vdropzone-file-added="addFileUpload"
                              v-on:vdropzone-success="successFileUpload"
                              v-on:vdropzone-complete="completeFileUpload"
                              v-on:vdropzone-sending="sendFileUpload"
                              ref="fileUpDropStatewide"
                              id="fileUpDropStatewide"
                              class="dropify-wrapper dropzoneContainer"
                              style="height: auto;"
                              :options="imageUploadDropzoneOptions"
                              :useCustomSlot="true">
                  <div class="dropify-message">
                    <div>
                      <i class='bx' :class="{'bx-camera': isMobile, 'bx-cloud-upload': !isMobile}"></i>
                      <p class="drop-down-text">
                        <template v-if="isMobile">Take Photo</template>
                        <template v-else>
                          Drag and Drop
                          <template v-if="type==='image'">Images</template>
                          <template v-else>Files</template>
                          Here
                        </template>
                      </p>
                    </div>
                    <p class="text-or">Or</p>
                    <div class="text-sm-center ex-image-upload-buttons">
                      <button type="button" :id="'clickBrowseFilesBtn_' + type" ref="vueDropzoneButton"
                              class="btn btn-primary waves-effect waves-light browse-btn">Browse
                        <template v-if="type==='image'">Images</template>
                        <template v-else>Files</template>
                      </button>
                      <button @click="openDropzone = false" type="button"
                              class="btn btn-secondary waves-effect waves-light cancel-btn">Cancel
                      </button>
                    </div>
                  </div>
                </vue-dropzone>
              </div>
            </div>
            <div>
              <image-lightbox
                  :isPreviewImage="true"
                  :imageList="imageSource"
                  @removeImage="deleteImage"
                  :path="''"
              >
              </image-lightbox>
            </div>
          </div>

          <div class="body-block-left-item" style="margin-top: 10px; height: 100px; position: absolute; bottom: 0; z-index: 1">
            <button
                @click="$emit('nextPage')"
                v-if="value.parts.length"
                style="width: calc(100% - 20px); min-width: 180px"
                class="btn btn-add-quote">Next</button>
          </div>
        </div>
      </div>
    </div>
    <input type="file" ref="fileInput" @change="onFileChange" accept=".jpg, .jpeg, .png" style="display: none;" />
  </div>
</template>

<style scoped>
.block-uploader >>> .vue-dropzone:hover{
  background-color: white;
}
.body-block-left-mobile-num-parts{
  display: none;
}
.body-block-left{
  width: 50%;
}
.body-block-right{
  width: 50%;
}
.right-banner{
  margin-top: 30px;
  width: 230px;
  font-size: 20px;
  position: sticky;
  top: 20px;
  height: 100%;
}
.right-banner-item-purple{
  background-color: #562a78;
  color: #fdcb2d;
  border-radius: 5px;
  font-weight: 600;
  padding: 20px;
  text-align: center;
}
.right-banner-item-grey{
  background-color: #d7d7d7;
  color: rgb(88, 43, 121);
  border-radius: 5px;
  padding: 20px;
  text-align: center;
  font-weight: 600;
}
.right-banner-item-white{
  font-weight: 400;
  padding: 40px 20px;
  font-size: 16px;
}
.right-banner-item-white-elem{
  margin-bottom: 30px;
}
.right-banner-item-white-elem-title{
  font-weight: 800;
}
.gray-table,
.gray-table input,
.gray-table i{
  color: #bfbfbf !important;
}
.available-right-block{
  width: 60%;
}
.body-block-left-item-name{
  width: 40%;
}
.body-block-left-item-input{
  width: 60%;
}
@keyframes donut-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.donut {
  position: absolute;
  top: 7px;
  right: 22px;
  display: inline-block;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-left-color: #7983ff;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: donut-spin 1.2s linear infinite;
}
.donut2 {
  position: absolute;
  top: 16px;
  right: 10px;
  display: inline-block;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-left-color: #7983ff;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: donut-spin 1.2s linear infinite;
}
.body-block-left-item-info-title{
  font-size: 15px;
  color: #6e309e;
  margin-bottom: 5px;
}
.body-block-left-item-info-name{
  color: #6e309e;
}
.body-block-left-item-info-num{
  font-weight: 400;
}
.body-block-left-item-info-availability,
.body-block-left-item-info-qty{
  font-weight: 500;
}
.body-block-left-item-info-qty{
  border-bottom: 1px solid rgba(0, 0, 0, .25);
  padding-bottom: 5px;
  margin-bottom: 5px;
}
.body-block-left-item-info{
  border: 2px solid rgba(0, 0, 0, .25);
  margin: 0 15px;
  height: 100%;
  padding: 0px 15px 15px 15px;
  border-radius: 3px;
}
.body-block-left-item-name div span{
  margin-top: 0;
  font-size: 13px;
}
.body-block-left-item-name div{
  margin-top: 15px;
  font-size: 13px;
}
.input-capricorn-num{
  height: 32px;
  width: calc(100% - 100px);
  margin-top: 10px;
  border: 2px solid rgba(28, 31, 57, 0.25);
  border-radius: 3px;
}
.input-capricorn-num.active{
  border: 2px solid #6e309e;
}
.btn-block-text{
  margin-top: 20px;
  font-size: 16px;
  color: #6e309e;
  font-weight: 600;
}
.body-block-right-title-error,
.body-block-right-title-text{
  font-weight: 600;
  display: block;
  margin-top: 5px;
  font-size: 15px;
}
.body-block-right-title-error{
  color: red;
}
.block-left-dealer{
  margin-top: 10px;
  border: 2px solid #d7d7d7;
  border-radius: 5px;
  padding: 10px 20px;
  width: calc(100% - 100px)
}
.block-left-dealer-title{
  font-weight: 600;
  font-size: 15px;
}
.block-left-dealer-name{
  font-weight: 600;
  font-size: 15px;
  margin-top: 5px;
  color: rgb(110, 48, 158);
}
.block-left-dealer-info{
  font-weight: 400;
  font-size: 15px;
  margin-top: 5px;
}
.body-block-right-subtitle span{
  font-weight: 600;
}
.body-block-right{
  position: relative;
  min-width: 330px;
}
.table-body-block-right-title{
  font-weight: 700;
  font-size: 15px;
}
.table-body-block-right-item .qty{
  width: 60px;
}
.body-block-right input{
  height: 32px;
  padding: 5px 5px 5px 10px;
  border-color: rgba(0, 0, 0, .25);
  border-radius: 3px;
}
.table-body-block-right-body{
  margin-top: 10px;
}
.table-body-block-right-head{
  margin-top: 25px;
}
.body-block-left-item-input >>> .multiselect__content-wrapper{
  z-index: 99999;
}
.body-block-left-item-input >>> .multiselect__content-wrapper ul li span{
  text-transform: uppercase;
}
.body-block-left-item{
  margin-top: 10px;
}
.wrapper-statewide{
  font-family: Roboto;
  font-weight: 900;
  margin: 50px auto;
  width: 930px;
}
.header-block{
  font-size: 25px;
  color: black;
  justify-content: space-between;
}
.header-auth{
  margin-top: 40px;
}
.header-line{
  background-color: rgb(227, 228, 231);
  height: 10px;
  border-radius: 5px;
  margin: 60px 45px 0;
  width: 250px;
}
.header-title{
  font-size: 19px;
  text-align: center;
  justify-content: space-between;
  margin-top: 18px;
  font-weight: 700;
}
.header-title-item.active{
  color: rgb(28, 31, 57);
}
.header-title-item{
  color: rgb(128, 130, 134);
}
.body-block{
  padding-top: 25px;
  border-top: 1px solid rgba(0, 0, 0, .25);
  overflow-x: auto;
  overflow-y: auto;
}
.body-block-left{
  border-right: 5px solid rgba(128, 128, 128, 0.4);
  margin-right: 20px;
  min-width: 380px;
}
.body-block-right-title{
  font-size: 19px;
}
.body-block-left-item-name{
  font-weight: 700;
  font-size: 15px;
  line-height: 16px;
  padding-top: 6px;
}
.body-block-left-item-name span{
  font-weight: 400;
  font-size: 14px;
  margin-top: 10px;
  display: block;
}
.body-block-left-title{
  margin-bottom: 25px;
  font-size: 19px;
}
.body-block-left-item-input{
  padding-right: 15px;
  padding-left: 15px;
  height: 32px;
  position: relative;
}
.body-block-left-item-input >>> .multiselect__tags{
  border: 2px solid rgba(0, 0, 0, .25);
}
.body-block-left-item-input input{
  padding: 5px 10px;
  width: 100%;
  position: relative;
  border-color: rgba(0, 0, 0, .25);
  border-radius: 3px;
}
.body-block-capricon-number-input{
  height: 32px;
  position: relative;
}
.body-block-capricon-number-input input{
  padding: 5px 10px;
  width: 100%;
  position: relative;
  border-color: rgba(0, 0, 0, .25);
  border-radius: 3px;
}
.btn-add-quote{
  padding: 5px 10px;
  width: 294px;
  height: 42px;
  border: 2px solid #6f309f;
  background-color: #6f309f;
  border-radius: 3px;
  color: white;
  font-weight: 900;
  cursor: pointer;
  font-size: 15px;
}
.btn-add-quote:hover{
  background-color: #5d2985;
  color: white;
}
.block-quote-success{
  background-color: #00af4f;
  border: 2px solid #00af4f;
  color: white;
  border-radius: 3px;
  padding: 8px;
  text-align: center;
  font-weight: 900;
  width: 294px;
}
.bx{
  font-size: 27px;
  position: relative;
  top: 3px;
  margin-left: 5px;
  color: #2e6ba3;
}
.clickable {
  cursor: pointer;
}
.body-block-right-subtitle{
  font-weight: 400;
  font-size: 15px;
  margin-top: 10px;
}
.main-subtitle span{
  font-weight: 800;
}
.main-text{
  font-size: 30px;
  color: rgb(88, 43, 121);
  text-align: center;
  margin-top: 50px;
  font-weight: 600;
  letter-spacing: 1.2px;
  margin-bottom: 50px;
}
.main-text span{
  font-family: "Inter", Arial, Helvetica, sans-serif;
}
.cards{
  flex-wrap: wrap;
}
.card{
  border: 1px solid black;
  margin: 40px 30px;
  padding: 10px 0;
  width: 138px;
  position: relative;
  height: 130px;
}
.card:hover{
  background-color: #f0f2f1;
}
.card img{
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
footer{
  background-color: #572b78;
  font-family: "Asap", serif;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
.footer-block{
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
}
.footer-logo{
  width: 40%;
}
.footer-main{
  width: 60%;
}
.footer-info{
  width: 33.333%;
}
.footer-info-title{
  color: #ebc018;
  font-size: 25px;
  line-height: 30px;
  font-weight: 700;
  letter-spacing: 1.2px;
  margin-bottom: 50px;
}
.footer-info-item{
  color: white;
  font-weight: 500;
  font-size: 22px;
  line-height: 30px;
  margin-bottom: 25px;
}
.btn.disabled{
  background-color: #c7c7c7;
  border-color:  #c7c7c7;
  color: white;
}
.btn-account-capricorn{
  background-color: white;
  color: #6f309f;
  margin-top: 20px;
}
.btn-account-capricorn:hover{
  background-color: #6f309f;
  color: white;
}
.capricorn-account-block-elem-name span{
  color: red;
  font-size: 18px;
}
.capricorn-account-block-elem-name{
  margin-top: 8px;
}
.capricorn-account-block-elem-input .input-capricorn-num{
  margin-top: 3px;
}
.input-capricorn-num[readonly]{
  border-color: rgba(0, 0, 0, .25);
  color: rgba(0, 0, 0, .25);
}
.body-block-left-item-input >>> .multiselect__content-wrapper .multiselect__option{
  font-size: 13px;
  height: 32px;
}
input{
  font-size: 13px;
}
@media (max-width: 1280px) {
  .left-block{
    width: auto;
  }
  .right-banner{
    display: none;
  }
  .good-wizard-block >>> .sticky .wizard__divider{
    display: block;
  }
  .body-block-left{
    min-width: auto;
  }
  .body-block-right{
    min-width: auto;
  }
  .wrapper-statewide{
    width: 100%;
  }
}
@media (max-width: 950px) {
  .right-banner{
    display: none;
  }
  .wrapper-statewide{
    margin-top: 20px;
  }
}
@media (max-width: 767px) {
  .body-block{
    display: block !important;
  }
  .body-block-left{
    width: 100%;
    margin-right: 0;
    border-right: 0;
    border-bottom: 5px solid #6f309f;
  }
  .body-block-right{
    width: 100%;
    margin-top: 25px;
  }
  .body-block-left-mobile-num-parts{
    display: block;
    color: #6f309f;
    height: 35px;
    font-size: 18px;
    text-align: center;
    width: 35px;
    background-color: #e0d4ea;
    border-radius: 999px;
    padding: 5px;
    font-weight: 900;
  }
  .body-block-left .body-block-left-item-input .bxs-camera{
    /*display: none;*/
  }
}
@media (max-width: 700px) {
  .body-block{
    margin-top: 0;
  }
  .wrapper-statewide{
    margin-top: 0;
    width: 100%;
  }
}
@media (max-width: 500px) {
  .body-block-left{
    min-width: 310px;
  }
  .body-block-left-item-input{
    min-width: 230px;
  }
  .available-right-block{
    width: 230px;
  }
  .body-block{
    padding: 5px 0;
  }
}

.red-blinker {
  animation: blinker 2s linear infinite;
}
@keyframes blinker {
  0% {
    border-color: red;
  }
  50% {
    border-color: rgba(0, 0, 0, .25);;
  }
}
</style>
